var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13342 7.00039H7.86675M4.13342 9.48928H7.86675M9.1112 12.6004H2.88898C2.20169 12.6004 1.64453 12.0432 1.64453 11.3559V2.64483C1.64453 1.95755 2.20169 1.40039 2.88898 1.40039H6.36458C6.5296 1.40039 6.68787 1.46595 6.80455 1.58264L10.1734 4.95148C10.2901 5.06817 10.3556 5.22643 10.3556 5.39146V11.3559C10.3556 12.0432 9.79849 12.6004 9.1112 12.6004Z",
    stroke: "#3AB44A",
    strokeWidth: 1.336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.dc9b8508413defd054b1e014c6022cc8.svg";
export { ForwardRef as ReactComponent };